import React from "react";
import { Document, Page } from "react-pdf";
import { Card, Typography, Spin } from "antd";
import { FileTextOutlined, EyeOutlined } from "@ant-design/icons";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";

const { Text } = Typography;

/**
 * PDF页面缩略图预览组件
 * 用于在拆分弹窗中展示PDF的单个页面
 */
const PDFPagePreview = ({ 
    pageNumber, 
    selected = false, 
    onClick, 
    width = 150,
    disabled = false 
}) => {
    const [isLoading, setIsLoading] = React.useState(true);
    const [hasError, setHasError] = React.useState(false);

    const handleLoadSuccess = () => {
        setIsLoading(false);
        setHasError(false);
    };

    const handleLoadError = (error) => {
        console.error(`页面${pageNumber}加载失败:`, error);
        setIsLoading(false);
        setHasError(true);
    };

    const [isHovered, setIsHovered] = React.useState(false);

    return (
        <Card
            size="small"
            hoverable={!disabled}
            onClick={() => !disabled && onClick && onClick(pageNumber)}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            style={{
                marginBottom: 8,
                border: selected ? "2px solid #1890ff" : "1px solid #d9d9d9",
                backgroundColor: selected ? "#e6f7ff" : "#fff",
                cursor: disabled ? "not-allowed" : "pointer",
                opacity: disabled ? 0.6 : 1,
                transition: "all 0.3s",
            }}
            bodyStyle={{ 
                padding: 8,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                position: "relative",
            }}
        >
            {/* 页码标签 */}
            <div style={{ 
                marginBottom: 4, 
                fontWeight: selected ? "bold" : "normal",
                color: selected ? "#1890ff" : "#666",
            }}>
                第 {pageNumber} 页
            </div>

            {/* 页面预览 */}
            <div style={{ 
                position: "relative", 
                width: width, 
                height: width * 1.414, // A4比例
                border: "1px solid #f0f0f0",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#fafafa",
            }}>
                {/* 悬停时显示放大图标 */}
                {isHovered && !disabled && onClick && (
                    <div style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 10,
                        transition: "all 0.3s",
                    }}>
                        <EyeOutlined style={{ fontSize: 32, color: "#fff" }} />
                    </div>
                )}
                {isLoading && !hasError && (
                    <Spin size="small" />
                )}
                {hasError ? (
                    <div style={{ textAlign: "center", color: "#999" }}>
                        <FileTextOutlined style={{ fontSize: 24, marginBottom: 4 }} />
                        <div style={{ fontSize: 12 }}>加载失败</div>
                    </div>
                ) : (
                    <Page
                        pageNumber={pageNumber}
                        width={width}
                        onLoadSuccess={handleLoadSuccess}
                        onLoadError={handleLoadError}
                        renderTextLayer={false}
                        renderAnnotationLayer={false}
                    />
                )}
            </div>

            {/* 选中标识 */}
            {selected && !disabled && (
                <div style={{ 
                    marginTop: 4,
                    fontSize: 12,
                    color: "#1890ff",
                    fontWeight: "bold",
                }}>
                    ✓ 已选中
                </div>
            )}
        </Card>
    );
};

export default PDFPagePreview;

